import * as Yup from "yup";

export const validationSchema = Yup.object({
  // member_id: Yup.string().required("Member is required!"),
  is_active: Yup.string().required("Status is required!"),
  name: Yup.string().required("Full name is required !"),
});
